module.exports = __webpack_public_path__ + "img/fastcharger-definitive-semipublic.848417bf.svg";